import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { ReasonOfAllowanceInsertService } from '../../service/reason-of-allowance-insert/reason-of-allowance-insert.service';

@Component({
	selector: 'app-reason-of-allowance-insert',
	templateUrl: './reason-of-allowance-insert.component.html',
	providers: [
		ReasonOfAllowanceInsertService,
		HttpModule
	]
})
export class ReasonOfAllowanceInsertComponent implements OnInit {

	private token;
	reasonOfAllowance: FormGroup;
	Nome: string = "";
	statusReasonOfAllowance: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private reasonOfAllowanceInsertService: ReasonOfAllowanceInsertService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.reasonOfAllowance = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addReasonOfAllowance(value: any) {
		this.reasonOfAllowanceInsertService.insertCompanyType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/motivo-do-abono');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/motivo-do-abono');
	}

}



// WEBPACK FOOTER //
// ./src/app/reason-of-allowance/component/reason-of-allowance-insert/reason-of-allowance-insert.component.ts